import { arrayType, booleanType, someType, stringType, functionType, objectType, } from '../_util/type';
import PropTypes from '../_util/vue-types';
const collapseProps = () => ({
    prefixCls: String,
    activeKey: someType([Array, Number, String]),
    defaultActiveKey: someType([Array, Number, String]),
    accordion: booleanType(),
    /** @deprecated Please use `destroyOnHidden` instead (antd ≥ 5.25). */
    destroyInactivePanel: booleanType(),
    /** Destroy inactive panel DOM when hidden (antd ≥ 5.25). */
    destroyOnHidden: booleanType(),
    bordered: booleanType(),
    expandIcon: functionType(),
    openAnimation: PropTypes.object,
    expandIconPosition: stringType(),
    collapsible: stringType(),
    ghost: booleanType(),
    /** Collapse size (antd ≥ 5.2). */
    size: stringType(),
    /** Collapse panels config (antd ≥ 5.6). */
    items: arrayType(),
    /** Semantic structure className (antd ≥ 5.21). */
    classNames: objectType(),
    /** Semantic structure style (antd ≥ 5.21). */
    styles: objectType(),
    onChange: functionType(),
    'onUpdate:activeKey': functionType(),
});
const collapsePanelProps = () => ({
    openAnimation: PropTypes.object,
    prefixCls: String,
    header: PropTypes.any,
    headerClass: String,
    showArrow: booleanType(),
    isActive: booleanType(),
    /** @deprecated Please use `destroyOnHidden` instead (antd ≥ 5.25). */
    destroyInactivePanel: booleanType(),
    destroyOnHidden: booleanType(),
    /** @deprecated Use `collapsible="disabled"` instead */
    disabled: booleanType(),
    accordion: booleanType(),
    forceRender: booleanType(),
    expandIcon: functionType(),
    extra: PropTypes.any,
    panelKey: someType(),
    collapsible: stringType(),
    role: String,
    onItemClick: functionType(),
    /** Semantic structure className from Collapse root. */
    classNames: objectType(),
    /** Semantic structure style from Collapse root. */
    styles: objectType(),
});
export { collapseProps, collapsePanelProps };
